import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//Styles
import './styles/styles.scss';

ReactDOM.render(<App />, document.getElementById('root'));
